<template>
    <div class="modal fade" id="termsAndConditionsModal" tabindex="-1" role="dialog" aria-labelledby="termsAndConditionsModalLabel" data-backdrop="static">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{eulaAgreement.header}}</h1>
                </div>
                <div class="modal-body">
                    <p class="center toc-title">COMODO TERMS AND CONDITIONS</p>
                    <p class="center toc-title">Valkyrie Threat Intelligence</p>
                    <br/>
                    <p>THIS AGREEMENT CONTAINS A BINDING ARBITRATION CLAUSE AND
                        CLASS ACTION WAIVER WHICH REQUIRES THE RESOLUTION OF
                        DISPUTES ON AN INDIVIDUAL BASIS, LIMITS YOUR ABILITY TO SEEK
                        RELIEF IN A COURT OF LAW, AND WAIVES YOUR RIGHT TO
                        PARTICIPATE IN CLASS ACTIONS, CLASS ARBITRATIONS, OR A JURY
                        TRIAL FOR CERTAIN DISPUTES.</p>
                    <br/>
                    <p>IMPORTANT—READ THESE TERMS CAREFULLY BEFORE USING VALKYRIE THREAT INTELLIGENCE (“SERVICES”).
                        BY USING THE SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS AND CONDITIONS, THAT YOU
                        UNDERSTAND THEM, AND THAT YOU AGREE TO THEM.  </p>
                    <br/>
                    <p>These terms and conditions (“Terms”) govern the relationship between you and Comodo Security Solutions,
                        Inc., with its principal place of business at 1255 Broad Street, Clifton, NJ 07013, United States, (“Comodo”)
                        with respect to your use of the Services.</p>
                    <br/><br/>
                    <p class="toc-title">1. Use of Services</p>
                    <br/>
                    <p>Please note that all data on Valkyrie Threat Intelligence is collected by Comodo from public internet sources
                        or provided to Comodo from third party affiliates. By use of Valkyrie Threat Intelligence, you as an organization,
                        and all the authorized personnel of your organization accept that the data displayed on Valkyrie Threat Intelligence
                        is only for the purpose of improving the security of your organization and to assist with potential threat avoidance.</p>
                    <br/>
                    <p>You acknowledge that sharing of the data, any content, diagram or screen image with sister companies, related organizations,
                        agents or affiliates is not authorized under any circumstances whether publicly or privately. You also acknowledge that
                        distribution of the data, any content, diagram, or screen image to any third party is prohibited.  The intelligence and
                        any data provided in this portal or through any API cannot be utilized in any publicly available publication without prior
                        notice to and written approval of Comodo Security Solutions, Inc. All users of the Services shall take every precaution to
                        preserve the non-disclosure of the data provided through the portal or any API.</p>
                    <br/>
                    <p>In order to use the Services, you will need to inform Comodo of the IP address(es) that  you  intend to use for access
                        to the portal and API.  Once provided, access shall be provided only to that IP address (es). In case the Services are not
                        used, you will need to inform the Comodo support team and request the IP address(es) to be removed from the access list.
                        You acknowledge and agree that Comodo may use any information (such as IPs, domains, brands, organizational or personnel
                        details) provided by you to collect and identify data related with your organization.
                    </p>
                    <br/>
                    <p>Any breach of these Terms and Conditions shall allow Comodo full recovery for all damages and any other relief and
                        remedies to the maximum extent allowable by law.</p>
                    <br/><br/>
                    <p class="toc-title">2. Restrictions</p>
                    <br/>
                    <p>You agree to not use the Services to:</p>
                    <p>i &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;engage in unlawful activity or to use the Services in an unlawful
                        manner</p>
                    <p>ii &nbsp;&nbsp;&nbsp;&nbsp;use the Services in any manner that is likely to damage, disable,
                        overburden or impair the Services (excluding the submission of malware to Comodo);</p>
                    <p>iii &nbsp;&nbsp;&nbsp;use automated scripts to collect information from or otherwise interact
                        with the Services;</p>
                    <p>iv &nbsp;&nbsp;&nbsp;transmit content that would reasonably be considered harmful, threatening,
                        unlawful, defamatory, infringing, abusive, inflammatory, harassing, vulgar, obscene, fraudulent,
                        invasive of privacy or publicity rights, hateful, or racially, ethnically or otherwise
                        objectionable;</p>
                    <p>v &nbsp;&nbsp;&nbsp;&nbsp;impersonate any person or entity, or falsely state or otherwise
                        misrepresent yourself;</p>
                    <p>vi &nbsp;&nbsp;&nbsp;transmit any private information; or</p>
                    <p>vii &nbsp;&nbsp;&nbsp;transmit content that would constitute or encourage criminal offense, violate the
                        rights of any party, create liability for Comodo, or violate any local, state, national or
                        international law.</p>
                    <br/><br/>
                    <p class="toc-title">3. Term</p>
                    <br/>
                    <p>These Terms and Conditions are effective for the time period indicated in any applicable purchase order,
                        unless terminated earlier as stated herein.</p>
                    <br/>
                    <p class="toc-title">4.	Disclaimer of Warranties</p>
                    <br/>
                    <p>ANY USE OF THE SERVICES IS AT YOUR OWN RISK AND The SERVICES may NOT OPERATE AS INTENDED.
                        COMODO, ITS AFFILIATES, AND THEIR LICENSORS, SUPPLIERS, EMPLOYEES OR AGENTS SHALL NOT BE RESPONSIBLE FOR
                        ANY USE OF THE SERVICES.  THE SERVICES MAY NOT OPERATE ERROR FREE, OR IN AN UNINTERRUPTED FASHION.
                        COMODO MAKES NO REPRESENTATIONS THAT ANY DEFECTS OR ERRORS IN THE SERVICES WILL BE CORRECTED OR THAT THE
                        SERVICES ARE COMPATIBLE WITH ANY PARTICULAR PLATFORM.</p>
                    <br/>
                    <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, COMODO DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESSED OR IMPLIED,
                        IN EQUITY OR AT LAW, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                        COMODO DOES NOT WARRANT THAT THE SERVICES WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS, OR THAT ACCESS TO THE SERVICES WILL BE
                        UNINTERUPTED, TIMELY, SECURE, OR ERROR-FREE.</p>
                    <br/><br/>
                    <p class="toc-title">5.	Permissions and Privacy Policy</p>
                    <br/>
                    <p>All data and information on Valkyrie Threat Intellignce is stored in an encrypted manner in secure environments.
                        For improvement to the Services, you acknowledge and approve that Comodo may continue to collect data related to your organization
                        from public sources and partners. </p>
                    <br/>
                    <p>If any information is provided by you which is not for the Valkyrie Threat Intelligence, Comodo shall follow the privacy
                        policy posted on its website at:</p>
                    <p>
                        <a href="https://www.comodo.com/repository/privacy-policy.php">https://www.comodo.com/repository/privacy-policy.php</a>
                    </p>
                    <p> and </p>
                    <p>
                        <a href="https://www.comodo.com/repository/css-information-collection.php">https://www.comodo.com/repository/css-information-collection.php</a>
                    </p>
                    <br/>
                    <p> when collecting and using information from you.  Comodo may amend the privacy policy at any time by posting the amended privacy
                        policy on its website. However, nothing in the privacy policy shall override these Terms and Conditions with regard to data and
                        information provided to Comodo.</p>
                    <br/>
                    <p class="toc-title">6.	Limitation of Liability</p>
                    <br/>
                    <p> COMODO, ITS LICENSORS, AND AFFILIATES SHALL NOT BE LIABLE FOR ANY LOSS OR DAMAGE RELATED TO THE USE OR INABILITY TO USE THE SERVICES.
                        COMODO WILL NOT BE LIABLE FOR ANY INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING INDIRECT, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES FOR
                        LOSS OF BUSINESS, LOSS OF PROFITS, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS INFORMATION OR DATA) EVEN IF COMODO HAS BEEN ADVISED OF THE
                        POSSIBILITY OF SUCH DAMAGES.  UNDER NO CIRCUMSTANCES SHALL COMODO’S LIABILITY EXCEED THE AMOUNT COMODO HAS RECEIVED FOR THE SERVICES IN THE
                        SIX MONTHS PRIOR TO THE EVENTS GIVING RISE TO ANY CLAIM. </p>
                    <br/>
                    <p> THE FOREGOING LIMITATIONS ON LIABILITY SHALL APPLY TO ALL CAUSES OF ACTION UNDER ALL LEGAL THEORIES, INCLUDING THEORIES OF CONTRACT, WARRANTY,
                        STRICT LIABILITY, MISREPRESENTATION, NEGLIGENCE, AND OTHER TORTS.  THE LIMITATIONS ON LIABILITY SHALL APPLY TO THE MAXIMUM EXTENT ALLOWED BY LAW.</p>
                    <br/>
                    <p class="toc-title">7.	Indemnity</p>
                    <br/>
                    <p>You agree to release, indemnify, defend and hold harmless Comodo and any of its contractors, agents, employees, officers, directors, shareholders,
                        affiliates and assigns from all liabilities, claims, damages, costs and expenses, including reasonable attorney's fees and expenses, of third parties
                        relating to or arising out of (a) your breach of these Terms, (b) falsehoods or misrepresentations of fact by you, or (c) your use or misuse of the Services.
                        Comodo has the right to participate in any defense of a third-party claim related to your use of the Services, with counsel of our choice. You shall have sole
                        responsibility to defend Comodo against any claim, but you must receive Comodo’s prior written consent regarding any related settlement. The terms of this paragraph
                        will survive these Terms.</p>
                    <br/>
                    <p>Your indemnification obligations are not Comodo’s sole remedy for a breach and are in addition to any other remedies Comodo may have against you under these Terms.
                        Your indemnification obligations survive the termination of these Terms.</p>
                    <br/><br/>
                    <p class="toc-title">8.	Arbitration / Governing Law</p>
                    <br/>
                    <p> ARBITRATION MEANS THAT YOU WAIVE YOUR RIGHT TO A JUDGE OR JURY TRIAL IN A COURT PROCEEDING AND YOUR GROUNDS FOR APPEAL ARE LIMITED.</p>
                    <br/>
                    <p>You agree that any dispute, claim or controversy arising out of this agreement shall be determined by binding arbitration. Before you may begin arbitration with respect to
                        a dispute involving any aspect of this Agreement, you shall notify Comodo and any other party to the dispute for the purpose of seeking dispute resolution. The notice to Comodo
                        should be addressed to 1255 Broad Street, Clifton, New Jersey 07013.</p>
                    <br/>
                    <p>If the dispute is not resolved within sixty (60) days after the initial notice, then a party may proceed in accordance with the following: Any unresolved dispute arising under
                        the terms of this Agreement shall be decided by arbitration conducted through the services of the Commercial Arbitration Rules of the American Arbitration Association (hereinafter referred to as the “AAA”)
                        . Notice of demand for an arbitration hearing shall be in writing and properly served upon the parties to this Agreement. Arbitration hearings shall be held in the state of New Jersey
                        at a location mutually agreeable to the parties.</p>
                    <br/>
                    <p>These Terms shall be governed by and construed in accordance with the laws of the state of New Jersey, United States of America, without regard to any conflicts-of-law rules.  You irrevocably consent
                        to the exclusive jurisdiction and venue of the federal and state courts of New Jersey and waive any right you may have to object to or seek to change such jurisdiction or venue.</p>
                    <br/>
                    <p>The United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act shall not apply to
                        this agreement and are specifically excluded.</p>
                    <br/>
                    <p><u>Waiver of Class Actions and Class Arbitrations:</u> Any proceedings to resolve or litigate any dispute in any forum will be conducted solely on an individual basis. Neither you nor Comodo will seek
                        to have any dispute heard as a class action, private attorney general action, or in any other proceeding in which either party acts or proposes to act in a representative capacity. No arbitration
                        or proceeding will be combined with another without the prior written consent of all parties to all affected arbitration or proceedings.</p>
                    <br/><br/>
                    <p class="toc-title">9.	Severability</p>
                    <br/>
                    <p>If any provision of these Terms is determined by a court of competent jurisdiction to be unenforceable or illegal, such provision shall be modified to the minimum extent necessary
                        to make the provision enforceable.  The remainder of the Terms shall remain in full force and effect.</p>
                    <br/><br/>
                    <p class="toc-title">10. Force Majeure</p>
                    <br/>
                    <p>Comodo is not responsible for any cessation, interruption or delay in the operation of the Services or performance of its obligations hereunder due to earthquake, flood, fire,
                        storm, natural disaster, act of God or the public enemy, war, armed conflict, terrorist action, strike, lockout, boycott, riot, release of hazardous or toxic substances, explosion,
                        accident, communications outages, Internet frailties, or any other causes whether or not of the same class or kind as those specifically above named.  </p>
                    <br/><br/>
                    <p class="toc-title">11. Waiver and Amendments</p>
                    <br/>
                    <p>A Party’s failure to enforce a provision of these Terms does not waive the party’s right to enforce the same provision later or right to
                        enforce any other provision of the Terms. Any waiver of these Terms shall only be effective if it is in writing and signed by both parties.
                        Comodo may change the Terms and the Services without prior notice to you.  You should check the Terms each time you use or access the
                        Services.  Your use of the Services after any changes to the Terms constitutes your acceptance of the new terms.  Section headings
                        are for convenience only and shall not be considered in the interpretation of these Terms.</p>
                    <br/><br/>
                    <p class="toc-title">12. Assignment</p>
                    <br/>
                    <p>You may not assign any of your rights or obligations under this agreement, whether by merger, consolidation, operation of law,
                        or any other manner, without the prior written consent of Comodo.  For purposes of this section only, a change in control is deemed
                        an assignment.  Any transfer without consent is void.  To the extent allowed by law, Comodo may assign its rights and obligations
                        without your consent.</p>
                    <br/><br/>
                    <p class="toc-title">13. Entire Agreement</p>
                    <br/>
                    <p>These Terms, along with any attached schedules and any documents referred to herein, is the entire agreement between the parties
                        with respect to the subject matter, superseding all other agreements that may exist with respect to the subject matter.
                        Section headings are for reference and convenience only and are not part of the interpretation of the agreement.</p>
                    <br/><br/>
                    <p class="toc-title">14. Notices</p>
                    <br/>
                    <p>All notices, demands or requests to Comodo with respect to these Terms shall be made in writing to:
                        Comodo Security Solutions, Inc., 1255 Broad Street, Clifton, New Jersey 07013.</p>
                    <br/><br/>
                    <p>ACCEPTANCE</p>
                    <br/>
                    <p>BY USING THE SERVICES OR CLICKING “SUBMIT”, YOU AGREE TO BE BOUND BY AND COMPLY WITH ALL OF THE TERMS HEREIN.
                        DO NOT USE THE SERVICES IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS.</p>
                    <div>
                        <input id="eulaRead" type=checkbox aria-label="read" style="font-weight: bold" @click="eulaReadClicked">
                        <span>I have read and agree to the Valkyrie Threat Intelligence Terms and Conditions</span>
                        <button id="agree-button" :disabled="!buttonActive" @click="onAgreeClickled"> AGREE & CONTINUE </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "terms-and-conditions-modal",
        data() {
            return {
                eulaAgreement: {},
                buttonActive: false,
                accept: false
            }
        },
        methods: {
            showModal() {
                this.eulaAgreement = {
                    header: "Specific Terms For Customer"
                }
                $('#termsAndConditionsModal').modal('show');
            },
            hideModal() {
                $('#termsAndConditionsModal').modal('hide');
            },
            eulaReadClicked(){
                if($('#eulaRead').prop('checked')){
                    this.buttonActive = true;
                }else{
                    this.buttonActive = false;
                }
            },
            onAgreeClickled(){
                this.$emit("eulaRead", {
                    accept: $('#eulaRead').prop('checked')
                });
            }
        },
        mounted() {
            $('#termsAndConditionsModal').modal({show: false});
        }
    }
</script>

<style scoped>

    .modal-dialog {
        height: 90% !important;
    }

    .modal-content {
        height: 100% !important;
        background-color: white !important;
    }

    .modal-body{
        overflow-y: scroll;
        max-height: 88% !important;
    }

    #agree-button {
        background-color: limegreen;
        border:none;
        height: 50px;
        color: white;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        right: 1%;
    }

    #agree-button:disabled {
        background-color: darkgrey;
    }

    h1{
        color: limegreen;
        font-family: 'Digital-Serial-Bold' !important;
    }

    p,span{
        font-family: 'Digital-Serial-Bold' !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/TermsAndConditionsModal.vue